"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPSGCodeSelectList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * EPSGCodeSelectList.tsx
 * Author: lnappenfeld
 * Date: 04.10.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const Input_1 = require("./Input");
const Global_1 = require("../functions/Global");
/*
Aktivieren wenn Postgis existiert
 */
const EPSGCodeSelectList = (props) => {
    const [list, setList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        (0, Global_1.getEPSGCodes)(props.projectId, props.keycloakfetch, props.settings).then(result => {
            const tmp = [];
            result.forEach((key) => {
                tmp.push({
                    value: key.code,
                    // label: key.code + ': ' + key.name,
                    label: key.name + ' (Code: ' + key.code + ')',
                });
            });
            setList(tmp);
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { name: props.name ? props.name : 'epsg_code', edit: true, disabled: typeof props.disabled === 'boolean' ? props.disabled : false, label: props.label, value: props.value, showClear: typeof props.disabled === 'boolean' ? props.disabled : false, dropdownOptions: list, scrollHeight: '350px', type: 'dropdown', onChange: (e) => {
            if (props.setValue)
                props.setValue(e.value);
            if (props.onChange)
                props.onChange(e);
        }, validationControl: props.validationControl, validationErrorMessage: props.validationErrorMessage, validationRules: props.validationRules }));
};
exports.EPSGCodeSelectList = EPSGCodeSelectList;
